import { isLocalHostname, isNetlifyHostname, isValidTenantSlug } from "./tenantResolver";

export interface StorefrontUrlOptions {
  hostname: string;
  origin: string;
  rootDomain?: string;
}

export function buildTenantStoreUrl(slug: string, options: StorefrontUrlOptions) {
  const normalizedSlug = slug.trim().toLowerCase();
  if (!isValidTenantSlug(normalizedSlug)) return null;

  if (isLocalHostname(options.hostname) || isNetlifyHostname(options.hostname)) {
    const url = new URL("/", options.origin);
    url.searchParams.set("store", normalizedSlug);
    return url.toString();
  }

  const rootDomain = (options.rootDomain || "pos.elmortechnologies.com").trim().toLowerCase();
  return `https://${normalizedSlug}.${rootDomain}`;
}
